import React from 'react';
import { Server } from '../../server/server';
import './HistoryPage.css'
import PageEnvelope from '../elements/PageEnvelope';

interface HistoryPageState {
  loading: boolean;
  log: any[];
}

class HistoryPage extends React.Component<{}, HistoryPageState> {
  constructor(props:{}) {
    super(props);
    this.state = {
      loading: false,
      log: []
    }
  }
  componentDidMount() {
    this.loadHistory();
  }

  async loadHistory() {
    this.setState({loading: true});
    let response = await Server.user.getLog();
    this.setState({loading: false});
    if(response.success)
      this.setState({log: response.log});
  }

  render() {
    let rows = [];
    let lastDate = null;
    let k = 0;

    for(let i = 0; i < this.state.log.length; i++) {
      let log = this.state.log[i];
      let d = new Date(log.date);
      let eventName = log.event;
      let eventData = '';

      if(!lastDate || lastDate.getDay() != d.getDay()) {
        if(lastDate)
          rows.push(<div key={k++} style={{height: '5px'}} />)
        lastDate = d;
        rows.push(<div key={k++} className="site-page-header">{d.toLocaleDateString()}</div>)
      }

      rows.push(
        <div key={k++} className="history-page-row">
          <div style={{whiteSpace: 'nowrap'}}>{d.toLocaleTimeString()}</div>
          <div>{eventName}<br/><div style={{color: '#ffffff80'}}>{eventData}</div></div>
        </div>
      )
    }

    if(rows.length == 0) {
      rows.push(<div key={k++}>There are no transactions in your history yet.</div>)
    }

    return (
      <div className="site-page">
        <PageEnvelope width="600px">
          <div className="site-page-panel">
            {this.state.loading ? 'Loading' : rows}
          </div>
        </PageEnvelope>
      </div>
    );
  }
}

export default HistoryPage;
